import { Paths } from "./path";

// Pages
import MainDashboard from "../pages/MainDashboard";
import ReportPage from "../pages/Report";
import AdminPage from "../pages/Admin";
import InfoPage from "../pages/Info";
import AccountStaff from "../pages/AccountStaff";
import CiriumScreen from "../pages/Cirium/CiriumService";
import BhashiniService from "../pages/Bhashini/BhashiniService";
import SelectService from "../pages/SelectService/SelectService";
import DashboardService from "../pages/SelectService/DashboardService";
import DataPage from "../pages/Data";

const routeObjectGenerator = (element, path) => {
	return { path, element }
};

const admin = [
	routeObjectGenerator(<MainDashboard />, Paths.Main),
	routeObjectGenerator(<ReportPage />, Paths.Report),
	routeObjectGenerator(<DataPage />, Paths.Data),
	routeObjectGenerator(<InfoPage />, Paths.App),
	routeObjectGenerator(<AdminPage />, Paths.Admin),
	routeObjectGenerator(<CiriumScreen />, Paths.CiriumScreen),
	routeObjectGenerator(<BhashiniService />, Paths.BhashiniService),
	routeObjectGenerator(<DashboardService />, Paths.DashboardService),
	routeObjectGenerator(<SelectService />, Paths.SelectService),
]

const staff = [
	routeObjectGenerator(<MainDashboard />, Paths.Main),
	routeObjectGenerator(<ReportPage />, Paths.Report),
	routeObjectGenerator(<InfoPage />, Paths.App),
	routeObjectGenerator(<AccountStaff />, Paths.Account),
]

export const routes = { admin, staff };
